import { render, staticRenderFns, recyclableRender, components } from "./addPersonnel.vue?vue&type=template&id=51e24e66&scoped=true&"
var renderjs
import script from "./addPersonnel.vue?vue&type=script&lang=js&"
export * from "./addPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./addPersonnel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addPersonnel.vue?vue&type=style&index=1&id=51e24e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e24e66",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/addPersonnel/addPersonnel.vue"
export default component.exports